import React, { useState, FC } from "react";
import { Button } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import ByzMuiTypography from "../../inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

const PAST_ICON_DEFAULT = "/assets/icons/past/past-button.svg";
const PAST_ICON_HOVER = "/assets/icons/past/past-button-hovered.svg";

interface ByzMuiPastButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  disabled?: boolean;
}

const StyledButton = styled(Button)(({ theme, disabled }) => ({
  borderRadius: 4,
  padding: "4px 20px",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  border: `1px solid ${
    disabled ? theme.palette.action.disabled : theme.palette.primary.main
  }`,
  backgroundColor: disabled
    ? alpha(theme.palette.action.disabled, 0.2)
    : alpha(theme.palette.primary.main, 0.1),
  color: disabled
    ? theme.palette.action.disabled
    : theme.palette.primary.main,
  cursor: disabled ? "not-allowed" : "pointer",
  "&:hover": {
    backgroundColor: disabled ? undefined : theme.palette.primary.main,
    color: disabled ? undefined : theme.palette.common.white,
  },
}));

const ByzMuiPastButton: FC<ByzMuiPastButtonProps> = ({
  onClick,
  disabled,
  children,
  ...rest
}) => {
  const [hover, setHover] = useState(false);
  const { t } = useTranslate();
  
  return (
    <StyledButton
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...rest}
    >
      <img
        src={hover ? PAST_ICON_HOVER : PAST_ICON_DEFAULT}
        alt="Past Icon"
        style={{ width: 20, height: 20, transition: "0.2s ease-in-out" }}
      />
      <ByzMuiTypography
        fontWeight={400}
        variant="body2"
        sx={{ display: "flex", alignItems: "center" }}
      >
        {t("buttons.past")}
      </ByzMuiTypography>
    </StyledButton>
  );
};

export default ByzMuiPastButton;
